<template>
  <div v-if="!this.hideMessageType.includes(this.messageType)" class="mailMessages" :key="index">
        <div :class="{'customerBg': isUser, 'counselorBg': isAgent}">
          <div class="mailCard">
            <div class="mailInfo">
              <div>
                <img :src="getChannelIcon(channelName)" alt="user-profile" width="50"/>
              </div>
              <div>
                <dl>
                  <dt>{{messageData.subject}}</dt>
                  <dd v-show="isUser">{{messageData.fromName}} {{messageData.fromAddress}}</dd>
                  <dd>To: {{messageData.recipientTo}}</dd>
                  <dd v-show="messageData.recipientCc" class="message-content-wrap">参照: {{messageData.recipientCc}}</dd>
                  <dd v-show="messageData.recipientBcc" class="message-content-wrap">隠れた参照: {{messageData.recipientBcc}}</dd>
                  <dd>{{getSentDate}}</dd>
                </dl>
              </div>
            </div>
            <div class="mailContent message-content-wrap" id="mail-message">
              <span class="mail-message-content" v-html="messageData.text"></span>
            </div>
            <div v-show="hasFiles" class="mailAttach">
              <dl>
                <dd v-for="(item, index) in messageData.files" :key="index">
                  <v-btn v-if="isAllowedFile(item)" :href="item.url" target="_blank" flat icon small outline color="#FFFFFF" class="downloadAttachBtn"><i class="UXicon-vertical_align_top"></i></v-btn>
                  <v-btn v-else flat icon small outline color="#FFFFFF" class="downloadAttachBtn attachDisable"><i class="UXicon-vertical_align_top"></i></v-btn>
                  <a v-if="isAllowedFile(item)" :href="item.url" target="_blank">{{ reduceFileName(item.name) }}</a>
                  <a v-else-if="item.isInvalidFile" class="attachFontDisable">[インポート失敗] {{ reduceFileName(item.name) }}</a>
                  <a v-else class="attachFontDisable">{{ reduceFileName(item.name) }} {{item.isInvalidFile}}</a>
                </dd>
                <dd>* 添付ファイルは {{ allowedFiles.join(' ') }} 形式のファイルのみサポートします。</dd>
              </dl>
            </div>
          </div>
        </div>
  </div>
</template>

<script>
import util from 'util/'
import helper from 'util/helpers'

export default {
  name: 'mail_messages',
  props: ['index', 'chat', 'channelName', 'userName', 'iconUrl'],
  data () {
    return {
      content: this.chat.content,
      messageData: {},
      messageType: this.chat.messageType,
      senderType: this.chat.senderType,
      hideMessageType: ['START', 'END', 'TAKE_OVER', 'HIDE_MESSAGE'],
      allowedFiles: ['jpg', 'jpeg', 'gif', 'png', 'pdf'],
      fileNameMaxLength: 45
    }
  },
  created () {
    this.messageData = JSON.parse(this.content)
  },
  computed: {
    getSentDate () {
      if (this.senderType === 'USER') {
        return this.printSentDateTime(this.messageData.sentDate)
      } else if (this.senderType === 'AGENT') return this.printSentDateTime(this.chat.createDate)
    },
    hasFiles () {
      return this.messageData.files && this.messageData.files.length > 0
    },
    isUser () {
      return this.senderType === 'USER'
    },
    isAgent () {
      return this.senderType === 'AGENT'
    }
  },
  methods: {
    getChannelIcon (moduleChannelName) {
      return moduleChannelName === 'MAIL' && this.iconUrl ? this.iconUrl : util.getChatRoomIcon(moduleChannelName)
    },
    printSentDateTime (datetimeString) {
      return helper.convertCreateDateToYYYY(datetimeString)
    },
    isAllowedFile (file) {
      const fileName = file.name
      if (!fileName.includes('.') || file.isInvalidFile) {
        return false
      }

      let fileExtension = fileName.split('.').pop()
      return this.allowedFiles.includes(fileExtension.toLowerCase())
    },
    reduceFileName (fileName) {
      return helper.reduceFileName(fileName, this.fileNameMaxLength)
    }
  }
}
</script>

<style lang="scss">
  .mailMessages {
    padding-top: 30px;
    &:first-child {
      padding-top: 10px;
    }
    > div {
      font-size: 14px;
      line-height: 22px;
      color: $gray-8;
      border-radius: 5px;
      margin-top: 20px;
      &:first-child{
        margin-top: 0;
      }
      &:last-child {
        /*margin-bottom: 30px;*/
        padding-bottom: 30px;
      }
      &.customerBg {
        background-color: $gray-0;
      }
      &.counselorBg {
        background-color: #FFE3E0;
      }
      .mailCard {
        padding: 20px;
        width: 100%;
        .mailInfo {
          display: flex;
          align-items: center;
          border-bottom: 1px solid #C4C4C4;
          padding-bottom: 20px;
          > div {
            img {
              border-radius: 50%;
              margin-right: 30px;
              height: 50px;
              object-fit: contain;
            }
            dl dt{
              font-weight: 700;
              word-break: break-all;
            }
          }
        }
        .mailContent {
          padding: 20px 0 20px 0;
          border-bottom: 1px solid #C4C4C4;
        }
        .mailAttach {
          dl {
            padding-top: 20px;
            dd {
              margin-top: 10px;
              &:first-child {
                margin-top: 0;
              }
              &:last-child {
                color: $gray-6;
                @include font-style(12px, 400, 16px);
              }
              .downloadAttachBtn {
                border-radius: 5px;
                border: 1px solid $pb_6;
                margin-right: 8px!important;
                &.v-btn {
                  margin: 0;
                  padding: 0;
                }
                &:hover {
                  background-color: $pb_1!important;
                }
                i {
                  color: $pb_6;
                  font-size: 16px;
                  transform: rotate(180deg);
                }
                &.attachDisable {
                  border: 1px solid $gray-5;
                  &:hover {
                    background-color: $gray-0!important;
                    //cursor: auto!important;
                  }
                  i {
                    color: $gray-5;
                  }
                }
              }
              a {
                color: $pb_6;
                @include font-style(12px, 400, 16px);
                &.attachFontDisable {
                  color: $gray-5;
                }
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/operation/fragments/chat_area/mail_messages.vue